<template>
  <div id="layout">
    <template v-if="!isForm">

      <LayoutHeaderWapMin v-if="isMobile" class="layout-header"
        :id="navID"
        :user="loginUser"
        :list="headNav"
        :subNav="topicNav"
        :ad="headAD"
        :notice="layoutNav.notice"
        :hideHeader="hideHeader"
        :headerInfo="info"
        :loginType="loginType"
        @noticeStatus="changeNoticeStatus"
        @login="login"
        @loginOut="loginOut"
      >
      </LayoutHeaderWapMin>

      <LayoutHeaderPcMin v-else class="layout-header"
        :hideHeader="hideHeader"
        :headerInfo="info"
        :eventStatu="eventStatu"
        :maxScrollTop="scrollTop"
        :linkType="linkType"
        :loginType="loginType"
        @login="login"
        @loginOut="loginOut"
      >
        <template slot="nav">
          <slot name="nav" />
        </template>
      </LayoutHeaderPcMin>
    </template>
    <template v-else>
      <LayoutHeaderForm
        :hideHeader="hideHeader"
        :headerInfo="info"
        :loginType="loginType"
        @loginOut="loginOut"
        @login="login"
      >
        <template slot="logo">
          <slot name="logo"></slot>
        </template>
      </LayoutHeaderForm>
    </template>
    <div
      class="inner-content"
      :class="{'hide-header': hideHeader, 'hide-footer': hideFooter}"
      :style="{'padding-bottom': isMobile && mobileBottomPadding && !isForm ? '60px' : '0'}"
    >
      <!-- 二级频道导航 -->
      <slot name="sub-nav">
        <div class="topic-nav nav" v-if="!hideHeader && !isMobile">
          <ul>
            <li>
              <a href="/" :class="{selected: navID == -1}">首页</a>
            </li>
            <template v-for="(nav, index) in topicNav">
              <li :key="nav.id" v-if="index < showLength">
                <a :class="{selected: navID == nav.id || navID == nav.alias}" :href="nav.type == 1 ? `/topic/${nav.alias || nav.id}` : nav.link" target="_blank" @click="navClick(nav.name)">
                  {{nav.name}}
                </a>
              </li>
            </template>
            <!-- <li v-for="item in ad" class="static" :key="item.alias">
              <AutoImage :src="item.icon" :scale="50" v-if="item.icon" />
              <a :href="item.link" target="_blank" @click="navClick(item.name)">{{item.name}}</a>
            </li> -->
            <li class="more" @click="toggleMoreNav">
              <span class="dot"></span>
              <transition name="slide-in">
                <div class="account-popup-box more-menu" v-if="showMore">
                  <ul>
                    <template v-for="(nav, index) in topicNav">
                      <li :key="nav.id" v-if="index >= showLength">
                        <a :class="{selected: navID == nav.id}" :href="nav.type == 1 ? `/topic/${nav.alias || nav.id}` : nav.link" target="_blank">
                          {{nav.name}}
                        </a>
                      </li>
                    </template>
                    <li>
                      <a href="/topics"  target="_blank">全部频道</a>
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
          </ul>
          <div class="nav-line"></div>
        </div>
      </slot>

      <slot />

      <div ref="footer" class="layout-footer-wrap" v-if="info.footer_type === 0">
        <FooterWap class="layout-footer" :user="loginUser" :bus="layoutNav.bus" :nav="layoutNav.footer" v-if="isMobile" />
        <FooterPc class="layout-footer" :user="loginUser" :bus="layoutNav.bus" :nav="layoutNav.footer" v-else >
          <template slot="footer-service">
            <slot name="footer-service" />
          </template>
        </FooterPc>
      </div>
      <div class="footer-self" v-if="info.footer_type === 2">
        <img :src="info.footer_content" alt="">
      </div>
    </div>
    <!-- <Modal class="offline-modal" :width="isMobile ? '84.66%' : '475px'" title="下线通知" :hasClose="false" :show="true" v-if="offlineModalStatus">
      <template slot="content">
        该帐号已在其他同类设备登录，如非本人操作，则密码可能已经泄露，建议立即更换密码
      </template>
      <div slot="footer">
        <gkButton color="blue" size="height40" label="知道了" @click="know"/>
      </div>
    </Modal> -->
  </div>
</template>

<script>
/* eslint-disable */
import VueTypes from 'vue-types'
import { mapState, mapMutations } from 'vuex'
import utils from '../../utils/'
import AccountService from '../../service/account.service'
import cookie from '../../utils/cookie'
import gkButton from 'gkui/button'

import LayoutHeaderPcMin from './header/Header.PC.min'
import LayoutHeaderForm from './header/Header.Form'
import LayoutHeaderWapMin from './header/Header.Wap.min'
import FooterPc from './footer/Footer.PC'
import FooterWap from './footer/Footer.Wap'

import Modal from '../modal/Modal'
import bizService from '../../service/biz.service'

export default {
  name: 'layout',
  components: {
    gkButton,
    LayoutHeaderPcMin,
    LayoutHeaderForm,
    LayoutHeaderWapMin,
    FooterPc,
    FooterWap,
    Modal
  },
  props: {
    loginType: VueTypes.number.def(0),
    scrollTop: VueTypes.number,
    info: VueTypes.object,
    hideHeader: VueTypes.bool.def(false),
    hideFooter: VueTypes.bool.def(false),
    eventStatu: VueTypes.string,
    linkType: VueTypes.number,
    isForm: VueTypes.bool.def(false)
  },
  data () {
    return {
      hideNotice: true,
      showMore: false
    }
  },
  computed: {
    ...mapState(['pageLoading', 'nowTime', 'isMobile', 'loginUser', 'layoutNav', 'offlineModalStatus', 'loginDomain']),
    navID () {
      const {name, meta, params} = this.$route
      return name === 'topic' ? params.id : meta.nav || -2
    },
    mobileBottomPadding () {
      if (this.linkType === 0) {
        return true
      } else if (this.linkType === 2) {
        if (this.eventStatu === 'processing') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    /**
     * 一级导航的菜单
     */
    headNav () {
      return [
        // {
        //   alias: 'conf',
        //   name: '算法训练营',
        //   icon: '',
        //   id: 'conf',
        //   link: 'https://time.geekbang.org/college/algorithm/100034301?utm_source=infoq_web&utm_medium=menu&utm_term=infoqwebmenu',
        //   type: 3
        // },
        {
          alias: 'conf',
          name: '技术大会',
          icon: '',
          id: 'conf',
          // link: 'https://www.geekbang.org/conference-schedule',
          link: 'https://www.infoq.cn/article/conference?utm_source=infoq&utm_medium=header_graybar',
          type: 3
        },
        {
          alias: 'tgo',
          name: '高端会员',
          icon: '',
          id: 'tgo',
          link: 'https://tgo.geekbang.org/ ',
          type: 3
        },
        // {
        //   alias: 'service',
        //   name: '团队学习',
        //   icon: '',
        //   id: 'service',
        //   link: 'https://service.geekbang.org/?utm_source=infoq&utm_medium=navbar&utm_campaign=servicehome',
        //   type: 3
        // },
        {
          alias: 'training',
          name: '算法训练营',
          icon: '',
          id: 'training',
          link: 'https://time.geekbang.org/college/algorithm/100034301?utm_source=infoq_web&utm_medium=menu&utm_term=infoqmenu',
          type: 3
        },
        {
          alias: 'time',
          name: '极客时间',
          icon: '',
          id: 'time',
          link: 'https://time.geekbang.org/',
          type: 3
        }
      ]
    },
    /**
     * 二级导航  频道列表
     */
    topicNav () {
      return this.layoutNav.header.reduce((list, item) => {
        item.type !== 3 && list.push(item)
        return list
      }, [])
    },
    /**
     * 可配置的两个导航外链
     */
    headAD () {
      return this.layoutNav.header.reduce((list, item) => {
        item.type === 3 && list.push(item)
        return list
      }, [])
    },
    showGeoBanner () {
      // 活动管理页面路由 加了 hideGeoBanner 参数，有这个参数的页面不显示banner
      return !this.geoClosed && !this.hideGeoBanner && this.inGeoTime && !this.$route.meta.hideGeoBanner
    },
    /**
     * 计算可显示的导航个数
     * 一共可以显示 40 个字符,中文算两个字符
     */
    showLength () {
      let length = 0

      this.topicNav.reduce((max, item) => {
        max -= item.name.replace(/[^\u0000-\u00FF]/g, 'xx').length
        max >= 0 && length++

        length = Math.min(length, 12)

        return max
      }, 92)

      return length
    }
  },
  watch: {
    layoutNav (val) {
      this.initNoticeStatus()
    },
    showMore (toggle) {
      toggle && document.addEventListener('click', this.listenerShowMore)
    }
  },
  created () {
    this.initNoticeStatus()
  },
  methods: {
    ...mapMutations({
      setModalVisible: 'OFFLINE_MODAL_STATUS'
    }),
    initNoticeStatus () {
      const storageNotice = utils.storage.get('headerNotice')
      this.hideNotice = !this.layoutNav.notice.content || storageNotice.close > this.layoutNav.notice.start_time && storageNotice.close < this.layoutNav.notice.end_time
    },
    /**
     * 初始化顶部公告的显示状态
     */
    changeNoticeStatus (status) {
      this.hideNotice = status
    },
    know () {
      this.setModalVisible(false)
      window.location.reload()
    },
    /**
     * 点击导航统计ga
     */
    navClick (name) {
      window.ga && window.ga('send', 'event', '导航点击', name)
    },
    /**
     * 开关更多的频道导航
     */
    toggleMoreNav () {
      if (this.showLength >= this.topicNav.length) {
        // this.navigation('/topics')
        window.open('/topics')
      } else {
        this.showMore = true
      }
    },
    listenerShowMore () {
      this.showMore = false
      document.removeEventListener('click', this.listenerShowMore)
    },
    loginOut () {
      const logoutServe = this.isForm && this.loginDomain === 'biz'
        ? bizService.logout
        : AccountService.logout
      logoutServe().then(() => {
        this.$store.commit('LOGOUT')
        // window.location.href = '//www.infoq.cn'
      })
    },
    login (type) {
      let message = type === 'form' ? '登录后才可提交表单' : '登录后才可报名活动'
      this.$Message.toast({
        message: message
      })

      utils.login()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

#layout {
  // display: flex;
  // flex-direction: column;
  width: 100%; min-height: 100vh;
  background: #F6F7F8;
}

.layout-header {
  position: fixed; left: 0; top: 0; z-index: 1000;
  background: #FFF;
  &:hover {
    z-index: 2000; // 热点文章页侧边栏z-index= 1001,会遮挡登录用户的下拉菜单。所有鼠标在header组件上时候，改变一下层级
  }
}

.layout-footer-wrap {
  position: relative;
  // z-index: 3;
}

.topic-nav {
  &.nav {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 54px 0 0;
    width: 1080px; height: 54px;
    margin: 0 auto;
    background: #F7F8F8;
    @extend %transition;

    & > ul {
      display: flex;
      transition: all 0.2s ease-out;
      // padding: 20px 0;
      & > li {
        height: 14px;
        margin: 0 18px;
        @include lineFont(14, 400);
        @extend %animateFontBlack;
        color: $bodyBlack;
        cursor: pointer;

        & a,
        & span {
          @extend %animateFontBlack;
          color: $bodyBlack;
        }

        & .selected {
          position: relative;
          font-weight: 400;
          color: $blue;
        }

        &.more {
          position: relative;
          @extend %center;
          width: 25px;
          text-align: center;

          & em {
            position: absolute; right: -6px; top: 0;
            width: 6px; height: 6px;
            background: $orange;
            border-radius: 6px;
          }

          & .dot,
          & .dot:before,
          & .dot:after {
            width: 3px; height: 3px;
            background: $black;
            border-radius: 3px;
          }

          & .dot {
            display: block;
            position: relative;
          }

          & span:before,
          & span:after {
            position: absolute; top: 0;
            content: ' ';
            display: block;
          }

          & span:before {
            left: -7px;
          }
          & span:after {
            right: -7px;
          }
        }

        &.landing {
          position: relative;

          &:after {
            content: '';
            position: absolute; right: -15px; top: -10px;
            width: 20px; height: 12px;
            background-size: contain;
            pointer-events: none;
          }
        }

        &.static {
          position: relative;

          & img {
            position: absolute; left: 100%; top: -10px;
          }
        }
      }
    }
  }
}

.account-popup-box {
  position: absolute; right: -17px; top: 100%; z-index: 20;
  padding-top: 16px;

  & ul {
    position: relative;
    width: 171px;
    padding: 18px 0 0px;
    background: #FFF;
    border: 1px solid $borderGray;
    box-shadow: $shadowGray;
    cursor: default;

    &:before,
    &:after {
      content: ' ';
      display: block;
      position: absolute; right: 20px;
      width: 0; height: 0;
    }

    &:before {
      top: -9px;
      border-bottom: 8px solid $borderGray;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }

    &:after {
      top: -8px;
      border-bottom: 8px solid #FFF;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
  }

  & li {
    // margin-top: 30px;
    // padding: 14px 0;
    text-align: center;
    @include lineFont(14, 400);
    @extend %transition;

    &.popup-avatar {
      position: relative;
      margin-top: 4px;
      padding: 0;

      &:after {
        content: ' ';
        display: block;
        position: absolute; left: 10px; bottom: 0; right: 10px;
        height: 1px;
        background: $borderGray;
      }

      & .avatar-box {
        & img {
          margin: 0 auto;
          border: 4px solid $borderGray;
        }

      }

      & h3 {
        box-sizing: border-box;
        padding: 10px 22px 19px;
        @extend %row;
        @include lineFont(18, 400);
        text-align: center;
      }
    }

    &:not(.popup-avatar):hover {
      background: $lightGray;

      & span,
      & a {
        @extend %animateFontBlack;
        color: $blue;
      }
    }

    & span,
    & a {
      display: block;
      padding: 14px 0;
      @extend %animateFontBlack;
      cursor: pointer;
    }
  }

  &.more-menu {

    & ul {
      padding-top: 24px;
    }

    & li {
      padding: 0;
      line-height: 14px;

      &:last-child {
        position: relative;

        &:before {
          content: ' ';
          display: block;
          position: absolute; left: 10px; top: 0; right: 10px;
          height: 1px;
          background: $borderGray;
        }
      }

      & span,
      & a {
        display: block;
        width: 100%; height: 100%;
      }

      & .selected:after {
        display: none;
      }
    }
  }
}

.inner-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 0;
  transition: padding-top 0.3s ease;

  &.had-notice {
    padding-top: 112px;
  }

  &.hide-header {
    padding-top: 0;
  }
  &.hide-footer {
    padding-bottom: 0;
  }

  & .footer-self {

    img {
      display: block;
      width: 100%; height: auto;
    }
  }
}

.offline-modal {
  & ::v-deep .content {
    padding: 44px;
    & .title {
      font-size: 24px;
      font-weight: 800;
    }

    & .main-body {
      margin: 32px 0;
      font-size: 14px;
      text-align: center;
      color: $lightBlack;
    }

    & [gk-button] {
      width: 128px;
    }
  }
}

@media screen and (max-width: 768px) {
  .inner-content {
    padding: 45px 0;
    background: #ffffff;

    &.hide-header {
      padding-top: 0;
    }
    &.hide-footer {
      padding-bottom: 0;
    }
  }

  .offline-modal {
    & ::v-deep .content {
      padding: 35px 32px 25px;

      & .main-body {
        margin: 28px 0 35;
      }
    }
  }
}
.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.3s ease;
}
.slide-in-enter,
.slide-in-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}
</style>
